import { z } from 'zod';

import { SessionSchema } from '@/types/schema';

export const conversationsExtraSchema = z.object({
  input: z.union([
    z.object({ type: z.literal('key-heuristic') }),
    z.object({ type: z.literal('key'), value: z.string() }),
    z.object({ type: z.literal('key'), value: z.array(z.string()) }),
  ]),
  output: z.union([
    z.object({ type: z.literal('key-heuristic') }),
    z.object({ type: z.literal('key'), value: z.string() }),
    z.object({ type: z.literal('key'), value: z.array(z.string()) }),
  ]),
});

export function getFormConversationsExtraValues(session?: SessionSchema) {
  const method = conversationsExtraSchema.safeParse(
    session?.extra?.conversations
  );
  if (method.success) {
    return {
      input:
        method.data.input.type === 'key' ? method.data.input.value : undefined,
      output:
        method.data.output.type === 'key'
          ? method.data.output.value
          : undefined,
    };
  }

  return { input: undefined, output: undefined };
}

export function getConversationExtraValues(
  data:
    | {
        input: string;
        output: string;
      }
    | {
        input?: string[];
        output?: string[];
      }
): z.infer<typeof conversationsExtraSchema> {
  return {
    input:
      // this looks weird but makes schema type discriminated so typescript works.
      data.input instanceof Array
        ? { type: 'key', value: data.input }
        : data.input
        ? { type: 'key', value: data.input }
        : { type: 'key-heuristic' },
    output:
      data.output instanceof Array
        ? { type: 'key', value: data.output }
        : data.output
        ? { type: 'key', value: data.output }
        : { type: 'key-heuristic' },
  };
}
